import React from 'react'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import { Link } from 'react-router'
import { FormProvider, useForm } from 'react-hook-form'
import { LoginFormSchema, LoginFormType } from '@App/entities/schemas/user/user-login'
import InputTextForm from '@App/kit/fields/v2/InputTextForm'
import { zodResolver } from '@hookform/resolvers/zod'
import { userLoginFormFields } from '@App/forms/user/user-login'
import MfaForm from '@App/kit/scenes/LoginScene/LoginForm/MfaForm'

interface LoginFormProps {
    mfaFunc: (e: any) => Promise<void>
    loginFunc: (e: any) => Promise<void>
    isFirstStepDone: boolean
    mfaDetails: { inactive: boolean; mfaType: string; mfaContactPoint: string }
}
const LoginForm = (props: LoginFormProps) => {
    const { mfaFunc, loginFunc, isFirstStepDone, mfaDetails } = props
    const loginFormFields = userLoginFormFields

    const methods = useForm<LoginFormType>({
        mode: 'onChange',
        criteriaMode: 'all',
        delayError: 750,
        resolver: zodResolver(LoginFormSchema),
    })

    return (
        <FormProvider {...methods}>
            <form className="login-form" onSubmit={methods.handleSubmit(isFirstStepDone ? mfaFunc : loginFunc)}>
                <input type="text" id="autoCompleteOff" autoComplete="off" style={{ display: 'none' }} />
                {isFirstStepDone ? (
                    <MfaForm
                        codeField={loginFormFields.code}
                        mfaType={mfaDetails.mfaType}
                        mfaContactPoint={mfaDetails.mfaContactPoint}
                        inactive={mfaDetails.inactive}
                    />
                ) : (
                    <>
                        <h3>Log in to The MLC Portal</h3>
                        <InputTextForm {...loginFormFields.username} />
                        <InputTextForm {...loginFormFields.password} />
                    </>
                )}
                <Button mainColor type="primary" icon={ICONS.arrow_forward} disabled={!methods.formState.isValid}>
                    Login
                </Button>
                <Link className="small bold link" to="/forgot-password">
                    Forgot password?
                </Link>
            </form>
        </FormProvider>
    )
}
export default LoginForm
